import { Injectable } from '@angular/core';

import { AgChartOptions } from 'ag-charts-community'

@Injectable({
  providedIn: 'root'
})
export class ChartsService {

  constructor(
  ) { }

  initStyleChartOptions(options: AgChartOptions): AgChartOptions {
    options.background = {
      visible: false
    }
    let legendColor: string
    legendColor = "#8a8a8a"

    options.legend = {
      item: {
        label: {
          color: legendColor
        },
        marker: {
          shape: "circle"
        }
      },
    }
    return options
  }
}
